import styled, {css} from 'styled-components/native';
import TextInputMask from 'react-native-text-input-mask';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';

interface InputError {
  error: boolean;
}

export const Container = styled.View`
  flex-direction: column;
`;

export const Form = styled.View`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const InputContainer = styled.View<InputError>`
  border-style: solid;

  flex-direction: column;

  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.border};

  height: ${RFValue(45)}px;
  justify-content: space-between;
  align-items: flex-start;

  ${({error}) =>
    error &&
    css`
      border-color: ${({theme}) => theme.colors.attention};
    `}
`;

//@ts-ignore
export const Input = styled(TextInputMask)<InputError>`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
  width: 100%;
  height: ${RFValue(45)}px;
  ${({error}) =>
    error &&
    css`
      color: ${({theme}) => theme.colors.attention};
    `}
`;

export const FormControl = styled.View`
  flex: 1;
  margin-left: ${RFValue(12)}px;
`;

export const Error = styled.Text`
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.attention};
  font-family: ${({theme}) => theme.fonts.medium};
  margin-top: ${RFValue(6)}px;
`;

export const ShowPassword = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
  height: ${RFValue(55)}px;
  padding: 0 14px;
`;

export const Icon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const Label = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;
